import { formatHTS } from '@xbcb/hts-client-utils';
import { HtsData, HtsObject } from 'types';
import { HtsValues } from './htsValuesContext';
import { MAX_HTS_CODES } from '../../libs/htsIndices';

export const getHtsValues = (
  htsNumbers: string[],
  data: HtsData,
): HtsValues => {
  const htsObjects: (HtsObject | undefined)[] = [];
  let lineHtsNumber: string | undefined;
  let lineHTSObj: HtsObject | undefined;
  let licenseCode: string | undefined;

  for (let i = 0; i < MAX_HTS_CODES; i++) {
    const htsNumber = htsNumbers[i] || '';
    const htsObj = data[formatHTS(htsNumber)];

    htsObjects.push(htsObj);

    if (htsObj) {
      lineHtsNumber = htsNumber;
      lineHTSObj = htsObj;
      licenseCode = htsObj.licenseCode || licenseCode;

      if (!htsObj.additionalHTS) {
        break;
      }
    } else {
      break;
    }
  }

  const validHtsNumbers = htsNumbers
    .slice(0, htsObjects.length)
    .filter(Boolean);

  return {
    lineHtsNumber,
    htsObjects,
    htsNumbers: validHtsNumbers,
    licenseCode,
    lineHTSObj,
  };
};
